import type { SiteUpdatePayload } from "@/types/tina";

export interface SiteEditValues {
  enabled: boolean;
  known_venue_id: string | null;
}

/** Read known_venue_id out of a site's config JSON (null if absent/blank). */
export function extractKnownVenueId(
  config: Record<string, unknown> | null | undefined,
): string | null {
  const value = config?.["known_venue_id"];
  return typeof value === "string" && value.length > 0 ? value : null;
}

/**
 * Build the PATCH body for a site edit. Config is sent WHOLESALE (the backend
 * replaces it), so we spread the current config and only overwrite
 * known_venue_id — preserving every other key (read-modify-write). The PATCH is
 * partial, so keys we omit (e.g. cadence_minutes) are left untouched.
 */
export function buildSiteUpdatePayload(
  values: SiteEditValues,
  currentConfig: Record<string, unknown> | null | undefined,
): Required<Pick<SiteUpdatePayload, "enabled" | "config">> {
  const config: Record<string, unknown> = { ...(currentConfig ?? {}) };
  const trimmed = values.known_venue_id?.trim() ?? "";
  config["known_venue_id"] = trimmed.length > 0 ? trimmed : null;
  return {
    enabled: values.enabled,
    config,
  };
}
